import { apiUrl, appStore, client } from "../modules/store";

export function getLastSyncCacheInvalidated() {
  return client.get(`${apiUrl}/organizations/syncInvalidated`);
}

export function uploadLogo(form) {
  return client.post(`${apiUrl}/organizations/logo/`, form);
}

export function getLogo() {
  return client
    .get(`${apiUrl}/organizations/logo`, {
      responseType: "blob",
    })
    .then((res) => res);
}

export function getOrgLogo(customerId) {
  return client
    .get(`${apiUrl}/organizations/logo/${customerId}`, {
      responseType: "blob",
    })
    .then((res) => res);
}

/** Current account slice from Redux (replaces former persist:account reads). */
export function getAccountFromLocalStorage() {
  return appStore.getState().account ?? null;
}

export function purgeAttachments(orgId) {
  return client.post(`${apiUrl}/organizations/purgeAttachments/${orgId}`);
}
